"use client";

import { FLOW_STEPS } from "./job-flow";
import type { Guide } from "./job-flow";

type JobStepGuideProps = {
  guide: Guide;
  reach?: { distanceLabel: string; etaLabel: string } | null;
  jobCode?: string;
  price?: number;
  onPrimaryAction?: () => void;
  primaryLabel?: string;
};

export default function JobStepGuide({
  guide,
  reach,
  jobCode,
  price,
  onPrimaryAction,
  primaryLabel,
}: JobStepGuideProps) {
  const activeIdx = Math.min(guide.step, FLOW_STEPS.length) - 1;

  return (
    <div className={`job-flow-panel ${guide.flash ? "flash-panel" : ""}`}>
      <div className="job-flow-track" aria-label="Trip progress">
        {FLOW_STEPS.map((label, index) => (
          <span
            key={label}
            className={index < guide.step ? "done" : index === activeIdx ? "current" : ""}
          >
            {label}
          </span>
        ))}
      </div>

      <div className="job-flow-hero">
        <small>{guide.kicker} · Step {guide.step} of {guide.total}</small>
        <h3>{guide.title}</h3>
        <p>{guide.detail}</p>
        {reach && guide.step <= 3 && (
          <div className="job-flow-reach">
            <b>{reach.etaLabel}</b>
            <span>to reach · {reach.distanceLabel} away</span>
          </div>
        )}
        {guide.showCodeMini && jobCode && (
          <span className={`job-code-mini ${guide.codeVerified ? "verified" : ""}`}>
            Code <strong>{jobCode}</strong>
            {guide.codeVerified ? " · verified ✓" : " · tell mistri when asked"}
          </span>
        )}
        {onPrimaryAction && primaryLabel && (
          <button type="button" className="job-flow-cta flash" onClick={onPrimaryAction}>
            {primaryLabel}
            {price ? ` · ₹${price}` : ""}
          </button>
        )}
      </div>
    </div>
  );
}
